/* eslint-disable react/no-danger */
import React from 'react';
import _, { isEmpty, map } from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZoneStandardOfficesBenefits({ data, id }) {
  const { title, text, items, threeCards, backgroundImage } = data;
  return (
    <section id={id} className="relative overflow-hidden bg-red">
      <div
        className={`py-[50px] md:py-[100px] z-10 relative flex flex-col
        gap-y-10   mx-auto px-6 3xl:px-0
        ${threeCards?'max-w-[1289px] md:gap-y-[50px]':'max-w-[1590px] md:gap-y-20'}`}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5 lg:gap-y-[30px] max-w-[1169px] mx-auto relative">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-white
          h2-child:leading-1.25 h2-child:md:leading-[125%] 
          h2-child:ltr:!font-DINMedium h2-child:rtl:!font-GESSTwoDWTCMedium
          h2-strong:!font-URWDINBold text-center h2-child:!m-0"
            />
            <div className="h-[2px] w-[50px] md:w-[70px] bg-white mx-auto" />
          </div>
          {_.isEmpty(text) || (
            <div
              dangerouslySetInnerHTML={{ __html: text }}
              className="p-child:text-white p-child:text-clamp12to18 p-child:font-normal
        p-child:leading-[1.6] p-child:mb-0 
        p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight 
        text-center"
            />
          )}
        </motion.div>
        {isEmpty(items) || (
          <div
            className={`flex flex-wrap [&>*]:flex-grow [&>*]:max-w-[calc(50%-8px)] 
              md:grid gap-x-4 md:gap-x-10 gap-y-[30px] [&>*]:md:max-w-none
            ${threeCards ? 'md:grid-cols-2 lg:grid-cols-3 ' 
            : 'md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5'}
            md:gap-y-[50px] justify-center`}>
            {map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.1 * (index + 1), delay: 0.6 }}
                className="flex flex-col gap-y-2 md:gap-y-5">
                {isEmpty(item.content.benefitsListIcon) || (
                  <div className="w-[67px] lg:w-[70px] xl:w-[90px] 
                  h-auto mx-auto flex">
                    <LazyLoadImage
                      src={item.content.benefitsListIcon.url}
                      width="100%"
                      effect="blur"
                      placeholderSrc={`${item.content.benefitsListIcon}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div className="flex flex-col gap-y-2">
                  <p
                    className="text-clamp14to18 text-[#e5e5e5] 
                    ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.375
                    text-center m-0 2xl:min-h-[55px]">
                    {item.content.benefitsListTitle}
                  </p>
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content.benefitsListText }}
                    className="p-child:text-[#e5e5e5] p-child:text-clamp12to16 p-child:font-normal
                    p-child:leading-[1.6] p-child:mb-0 
                    p-child:ltr:font-URWDINRegular 
                    p-child:rtl:font-GESSTwoDWTCLight text-center hidden
                    md:flex"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
      {isEmpty(backgroundImage) || (
        <img
          src={backgroundImage.url}
          alt="Benefits"
          className="absolute inset-0 object-cover h-full w-full bg-blend-multiply opacity-15"
        />
      )}
    </section>
  );
}
